$(document).ready(function(){
    $('body').scrollspy({target: ".navbar", offset: 100});
});

/* ContentElement: MenuItem - for creating a menu */
var menuheaderentries = '';
var tmp = document.querySelectorAll('.menuitem');
for (var i = 0; i < tmp.length; i++) {
    menuheaderentries = menuheaderentries + '<li class="nav-item"><a href="#' + tmp[i].id + '" id="' + tmp[i].id + '_menu" class="nav-link">' + tmp[i].dataset['title'] + '</a></li>';
}
if (menuheaderentries.length > 0) {
    var element = document.querySelector('#navbarNavDropdown .pagemenu');
    element.innerHTML = element.innerHTML + '<ul class="navbar-nav">' + menuheaderentries + '</ul>';
}


function highlightCurrentNavElement(element) {
    document.getElementById(element.id + '_menu').classList.add('active');
}

function removeCurrentNavElement(element) {
    document.getElementById(element.id + '_menu').classList.remove('active');
}
